import React, { useState } from "react";
import Modal from "react-modal";
import "./index.css";
import SiteConfig, { HelpContent } from "../../siteConfig";

function HelpButton() {
    const [modalOpen, setModalOpen] = useState(false);

    return (
        SiteConfig.hasOwnProperty("help-button-color") && (
            <div className="help-button">
                <button
                    className="btn btn-sm"
                    style={{
                        backgroundColor: SiteConfig["help-button-color"],
                        color: SiteConfig["help-button-font-color"]
                    }}
                    onClick={() => setModalOpen(true)}
                >
                    Help
                </button>
                <Modal
                    isOpen={modalOpen}
                    onRequestClose={() => setModalOpen(false)}
                    className="modal-dialog"
                    overlayClassName="modal twc-modal"
                >
                    <div className="modal-content">
                        <div className="modal-header">Help Dialog</div>
                        <div className="modal-body">
                            <HelpContent />
                        </div>
                        <div className="modal-footer">
                            <button
                                className="btn btn-primary"
                                onClick={() => setModalOpen(false)}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </Modal>
            </div>
        )
    );
}

export default HelpButton;



// WEBPACK FOOTER //
// ./src/components/helpButton/helpButton.js